import { useEffect, useRef } from 'react';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';


export default function Popover({ onClose, setPosition, parent, className, children }) {
    const contentRef = useRef(null);

    useEffect(() => {
        const handleKeyDown = (e) => { if (e.keyCode === 27) onClose(); };
        const handleResize = () => onClose();
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('resize', handleResize);
        };
    }, [onClose]);

    if (!parent) return null;

    const domRect = parent.getBoundingClientRect();
    const position = setPosition(domRect);

    const handleClick = (e) => {
        if (!contentRef.current.contains(e.target)) onClose(e);
        e.stopPropagation();
    };

    return ReactDOM.createPortal(
        <div className={cx("fixed z-50 top-0 left-0 h-full w-full", className)} onClick={handleClick}>
            <div className="absolute" ref={contentRef} style={{ ...position }}>
                {React.cloneElement(children, { onClose })}
            </div>
        </div>,
        document.body
    );
}
